var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "record-wrapper",
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("img", {
        staticClass: "preview-container",
        attrs: { src: _vm.thumbnail }
      }),
      _vm._v(" "),
      _c("div", { staticStyle: { margin: "12px 8px" } }, [
        _c("div", { staticClass: "record-name single-line-text" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "record-date" }, [
          _vm._v(_vm._s(_vm.studyDate))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "record-date" }, [
          _vm._v(_vm._s(_vm.provider))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }